import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomFieldsService } from '../../services/custom-fields.service';
import { CustomField, CustomFieldDataType, CustomFieldValue } from '../../models/custom-field.model';

/**
 * Read-only display of an HCO/HCP's custom field values (profile / details views), one
 * label + value line per active field. Yes/No fields get a switch when `canToggle` is set;
 * the parent saves the change through its normal save path. Nothing renders while the
 * feature setting is off.
 */
@Component({
  selector: 'crm-custom-field-values',
  templateUrl: './custom-field-values.component.html'
})
export class CustomFieldValuesComponent implements OnInit {
  @Input() entity: 'hco' | 'hcp';
  @Input() values: CustomFieldValue[];
  @Input() canToggle = false;
  @Input() busy = false;
  @Input() labelClass = 'col-md-3';
  @Input() valueClass = 'col-md-9';
  @Output() toggle = new EventEmitter<{ fieldId: number, value: string }>();

  fields: CustomField[] = [];

  constructor(private readonly customFieldsService: CustomFieldsService) {
  }

  ngOnInit() {
    this.customFieldsService.getActive(this.entity).subscribe(fields => this.fields = fields || []);
  }

  isBoolean(field: CustomField): boolean {
    return field.dataType === CustomFieldDataType.Boolean;
  }

  rawOf(field: CustomField): string {
    const v = (this.values || []).find(x => x.fieldId === field.id);
    return v ? v.value : '';
  }

  displayOf(field: CustomField): string {
    const v = (this.values || []).find(x => x.fieldId === field.id);
    return v && v.displayValue ? v.displayValue : '-';
  }

  onToggle(field: CustomField, checked: boolean) {
    this.toggle.emit({ fieldId: field.id, value: checked ? 'True' : 'False' });
  }
}
